<template>
  <section class="p-1">
    <!-- <bread-crumb :bread-crumbs="['Compliance', 'List of Customers']" /> -->

    <v-card class="mb-2 ma-2">
      <v-card-title class="mt-0 pt-0">
        <span class="me-2 font-weight-normal"
          >Txn Pin Number: {{ $route.query.pin_no }}</span
        >
        <v-chip v-if="riskLevel" label small :color="returnColor(riskLevel)">
          <span>{{ riskLevel }}: {{ $route.query.percentage }}%</span>
        </v-chip>
        <v-chip color="error" class="ms-2" small v-if="isRiskSetupDone">
          <span class="">{{
            isRiskSetupDone ? "Risk Setup Incomplete" : ""
          }}</span>
        </v-chip>
        <v-spacer></v-spacer>
        <v-btn depressed @click="downloadExcelsheet" color="primary" small
          ><v-icon small>mdi-file-excel-outline</v-icon>Export
        </v-btn>
        <v-btn
          depressed
          :disabled="!$route.query.pin_no"
          @click="getRecalculateScore()"
          color="primary"
          class="ms-2"
          small
          ><v-icon small>mdi-calculator</v-icon>Re-Calculate
        </v-btn>
      </v-card-title>
      <v-divider class="p-0 m-0 primary--text"></v-divider>
      <v-data-table
        fixed-header
        height="55vh"
        :headers="headers"
        :items="riskProfiling"
        :items-per-page="
          riskProfiling.length > 0 ? riskProfiling.length + 1 : 10
        "
        dense
        item-key="name"
      >
      </v-data-table>
    </v-card>
    <v-row class="my-2 mx-1">
      <v-col cols="12" md="6" lg="6" sm="12">
        <v-card class="ps-4" height="320px">
          <div id="chart">
            <apexchart
              type="rangeBar"
              height="320"
              :options="chartOptions"
              :series="series"
            ></apexchart>
          </div>
        </v-card>
      </v-col>
    </v-row>

    <loading :active="loader" :opacity="0.9" color="#ff6b00" />
  </section>
</template>

<script>
import commonService from "@/services/CommonService/commonService.js";
import setupService from "@/services/SetupService/setupService.js";
import Loading from "vue-loading-overlay";
import { mapState } from "vuex";
export default {
  name: "Risk Profiling",
  data: () => {
    return {
      riskLevel: "",
      series: [],
      isRiskSetupDone: null,
      chartOptions: {
        chart: {
          height: 250,
          type: "rangeBar",
          toolbar: {
            show: false,
          },
        },
        plotOptions: {
          bar: {
            horizontal: true,
            barHeight: "20%",
            rangeBarGroupRows: true,
          },
        },
        colors: ["#008000", "#FFA500", "#FF0000", "#ff6b00"],
        fill: {
          type: "solid",
        },
        title: {
          text: "Profile Risk Score",
          align: "left",
        },
        xaxis: {
          type: "Percentage",
        },
        legend: {
          position: "right",
        },
      },
      loader: false,
      headers: [
        { text: "S.no", value: "sno", sortable: false },
        { text: "Risk Profiling", value: "risk_type", sortable: false },
        { text: "Customer Details", value: "risk_sub_type", sortable: false },
        { text: "Weight", value: "weight", sortable: false },
        { text: "Score", value: "risk_score", sortable: false },
      ],

      riskProfiling: [],
    };
  },
  components: {
    Loading,
    // listOverviewVue
  },
  computed: {
    ...mapState(["CustomerRouteData"]),
  },
  watch: {},
  mounted() {
    this.getRiskProfilingData();
    this.getRiskscore();

    console.log("CustomerRouteData", this.CustomerRouteData);
  },
  methods: {
    returnColor(val) {
      if (val.toLowerCase() == "medium") {
        return "orange";
      } else if (val.toLowerCase() == "high") {
        return "error";
      } else if (val.toLowerCase() == "low") {
        return "success";
      }
      return;
    },
    async downloadExcelsheet() {
      if (this.riskProfiling) {
        this.exportToExcel(
          this.headers,
          this.riskProfiling,
          "List of customers",
        );
      }
    },
    stoploader() {
      setTimeout(() => {
        this.loader = false;
      }, 400);
    },
    async getRiskscore() {
      this.loaderOverlay = true;
      try {
        const response = await setupService.getRiskscore("ITR");
        if (response.data.status_code === 200) {
          console.log("ITR codes", response.data.data);
          this.series = response.data.data.map((ele) => {
            return {
              name: `${ele.risk_status}: ${ele.min_risk_score}-${ele.max_risk_score}`,
              data: [
                {
                  x: "Risk Range",
                  y: [ele.min_risk_score, ele.max_risk_score],
                },
              ],
            };
          });
          this.series.push({
            name: "Customer",
            data: [
              {
                x: "Customer",
                y: [this.series[0].data[0].y[0], this.$route.query.percentage],
              },
            ],
          });
          this.transItems = response.data.data;
        }
      } catch (error) {
        this.transItems = [];

        console.error(error);
      }
    },
    isRiskDataNotFound(responseData) {
      return (
        responseData &&
        responseData.status_code === 404 &&
        responseData.message &&
        responseData.message.includes("Risk Data Not Found")
      );
    },
    async getRecalculateScore(isAutoRecalculate = true) {
      this.loaderOverlay = true;
      if (this.$route.query.pin_no) {
        try {
          const response = await commonService.getRecalculateScore(
            this.$route.query.pin_no,
          );
          if (response.data.status_code === 200) {
            await this.getRiskProfilingData(isAutoRecalculate);
            await this.getRiskscore();
          } else {
            this.showAlertError(
              `Failed to Re-Calculate: ${response.data.message}`,
            );
          }
        } catch (error) {
          console.error(error);
        }
      }
    },
    async getRiskProfilingData(isAutoRecalculated = false) {
      this.loader = true;
      try {
        const response = await commonService.getRiskProfilingData(
          null,
          this.$route.query.pin_no,
        );
        if (response.status === 200) {
          if (this.isRiskDataNotFound(response.data)) {
            if (!isAutoRecalculated) {
              await this.getRecalculateScore(true);
              return;
            }
            this.showAlertError(`Failed to fetch: ${response.data.message}`);
            this.stoploader();
            return;
          }
          let indexVal = 0;
          response.data.data[0].risk_data.map((ele) => {
            indexVal = indexVal + 1;
            ele.sno = indexVal;
            this.riskProfiling.push(ele);
          });
          this.riskProfiling = response.data.data[0].risk_data;
          this.riskLevel = response.data.data[0].risk_level;
          this.isRiskSetupDone = response.data.data[0].is_incomplete;
          const currentQuery = { ...this.$route.query };
          currentQuery.percentage = response.data.data[0].risk_percentage;
          // currentQuery.percentage = "";
          this.$router.replace({ query: currentQuery });
          this.riskProfiling.push({
            risk_type: "",
            risk_sub_type: `Risk Level: ${response.data.data[0].risk_level}`,
            weight: "Total",
            risk_score: `${this.$route.query.percentage} %`,
          });
          this.stoploader();
        } else {
          this.showAlertError(`Failed to fetch: ${response.data.message}`);
        }
        console.log("countryOptions", this.riskProfiling);
      } catch (e) {
        if (this.isRiskDataNotFound(e) && !isAutoRecalculated) {
          await this.getRecalculateScore();
          return;
        }
        if (this.isRiskDataNotFound(e)) {
          this.showAlertError(`Failed to fetch: ${e.message}`);
        }
        console.error(e);
        this.stoploader();
        this.riskProfiling = [];
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/global.scss";

// tr:hover {
//   background: none !important;
// }
th {
  text-transform: uppercase;
}

.border {
  color: #ee0d0d;
}
.apexcharts-toolbar {
  display: none !important;
}
</style>
